import axios from "axios";
import * as types from "../mutation-types";
import { getProjectByProId } from "./projects";
import { getEventIndexById } from "./fullcalendar";
import logger from "~/utilities/logger";

// state
export const state = {
  location_list: [],
  location_select: null,
  the_id: null,
};

// getters
export const getters = {
  location_list: (state) => state.location_list,
  check_list: (state) => state.location_list !== null,
  location_select: (state) => state.location_select,
  the_id: (state) => state.the_id,
};

//utils
export const getLocationIndexById = (state, locId) =>
  state.location_list.findIndex(
    (location) => location.loc_id.toString() === locId.toString()
  );
export const getLocationByLocId = (state, locId) =>
  state.location_list.find(
    (location) => location.loc_id.toString() === locId.toString()
  );

// mutations
export const mutations = {
  [types.ADD_LOCATION](state, location)
  {
    return state.location_list.push(location);
  },
  [types.ADD_LOCATION_FAILURE](state, error) {},

  [types.FETCH_LOCATIONS](state, { location_list })
  {
    return (state.location_list = location_list);
  },

  [types.FETCH_LOCATIONS_FAILURE](state)
  {
    logger.error("FETCH_LOCATIONS_FAILURE");
  },

  [types.FETCH_LOCATION](state, { location_select })
  {
    return (state.location_select = location_select);
  },

  [types.FETCH_LOCATION_FAILURE](state, { error })
  {
    logger.error("FETCH_LOCATION_FAILURE", error);
  },

  [types.SELECT_LOCATION](state, { loc_id })
  {
    let theSelect = getLocationByLocId(state, loc_id);
    logger.log("store.SELECT_LOCATION", theSelect);
    return (state.location_select = theSelect);
  },

  [types.DESELECT_LOCATION](state)
  {
    return (state.location_select = null);
  },

  [types.DELETE_LOCATION](state, { loc_id })
  {
    logger.log("store.DELETE_LOCATION", state, loc_id);
    const index = getLocationIndexById(state, loc_id);
    if (index === -1)
    {
      return console.warn(`Unable to delete location (id ${loc_id})`);
    }
    return state.location_list.splice(index, 1);
  },

  [types.UPDATE_LOCATION](state, { payload }) {},

  [types.SET_LOCATION_ID](state, { id })
  {
    return (state.the_id = id);
  },

  [types.SEARCH_LOCATIONS](state, { location_list })
  {
    return (state.location_list = location_list);
  },

  [types.SEARCH_LOCATIONS_FAILURE](state, error)
  {
    logger.error("SEARCH_LOCATIONS_FAILURE", error);
  },
};

// actions
export const actions = {
  async addLocation({ commit }, location)
  {
    try
    {
      logger.log("store.addLocation", "/api/locations", location);
      const { data } = await axios.post("/api/locations", location);
      if (data.status && data.status === "success")
      {
        logger.log("store.addLocation rsp", data);
        return commit(types.ADD_LOCATION, data.data);
      } else
      {
        return commit(types.DELETE_LOCATION_FAILURE, data);
      }
    } catch (e)
    {
      logger.log("DELETE_LOCATION_FAILURE", e);
      return commit(types.DELETE_LOCATION_FAILURE, e);
    }
  },

  async getLocations({ commit }, options)
  {
    try
    {
      let paginate = options && options.paginate ? options.paginate : 10000;
      let with_status =
        options && options.with_status ? options.with_status : null;
      let the_status =
        options && options.the_status ? options.the_status : null;
      let extraOptions =
        options && options.extra_options ? options.extra_options : "";
      let format = options && options.format ? options.format : "minimal";

      if (the_status)
      {
        const { data } = await axios.get(
          `/api/locations?status=${the_status}&paginate=${paginate}&format=${format}${extraOptions}`
        );
        logger.log("store.getLocations the_status", data);
        return commit(types.FETCH_LOCATIONS, { location_list: data.data.data });
      } else if (with_status)
      {
        const { data } = {};
        const { data2 } = await axios.get(
          `/api/locations?status=${with_status}&paginate=${paginate}&format=${format}${extraOptions}`
        );
        if (data && data2)
        {
          data.data.data = data.data.data.concat(data2.data.data);
        }
        logger.log("store.getLocations with_status", data);
        return commit(types.FETCH_LOCATIONS, { location_list: data.data.data });
      } else
      {
        const { data } = await axios.get(
          `/api/locations?status=active&paginate=${paginate}&format=${format}${extraOptions}`
        ); //todo
        logger.log("store.getLocations", data);
        return commit(types.FETCH_LOCATIONS, { location_list: data.data.data });
      }
    } catch (e)
    {
      logger.error("store.getLocations error", e);
      return commit(types.FETCH_LOCATIONS_FAILURE);
    }
  },

  async getLocation({ commit, dispatch }, payload)
  {
    if (!payload.loc_id) return;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    let format = payload && payload.format ? payload.format : "minimal";
    try
    {
      const { data } = await axios.get(`/api/locations/${payload.loc_id}`);
      logger.log("store.getLocation rsp", data);
      return commit(types.FETCH_LOCATION, { location_select: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_LOCATION_FAILURE, { error: e });
    }
  },

  async deleteLocation({ commit, dispatch }, payload)
  {
    if (!payload.loc_id) return;
    let paginate = payload && payload.paginate ? payload.paginate : 10000;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    try
    {
      const { data } = await axios.delete(
        `/api/locations/${payload.loc_id}${extraOptions}`
      );
      logger.log("store.deleteLocation rsp", data);
      return commit(types.DELETE_LOCATION, { loc_id: payload.loc_id });
    } catch (e)
    {
      logger.log(e);
      return commit(types.DELETE_LOCATION_FAILURE, { error: e });
    }
  },

  async updateLocation({ commit, dispatch }, payload)
  {
    try
    {
      const { data } = await axios.put(
        `/api/locations/${payload.org_id}`,
        payload
      );
      logger.log("store.updateLocation", data);
      return commit(types.UPDATE_LOCATION, { payload: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_LOCATION_FAILURE, { error: e });
    }
  },

  setLocationID({ commit, dispatch }, id)
  {
    return commit(types.SET_LOCATION_ID, { id: id });
  },

  async searchLocations({ commit }, query)
  {
    try
    {
      const { data } = await axios.get(`/api/locations?search=${query}`);
      logger.log("store.searchLocations", data);
      return commit(types.SEARCH_LOCATIONS, { location_list: data.data.data });
    } catch (e)
    {
      logger.error("store.searchLocations error", e);
      return commit(types.SEARCH_LOCATIONS_FAILURE, e);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
